import {casaApiUrl} from '../configs/casa-api'

const getLinkForUser = data => {
  return fetch(`${casaApiUrl}/rse-referrals/get-link`, {
    credentials: 'include',
    method: 'POST',
    body: JSON.stringify(data),
    headers: {
      'Content-type': 'application/json'
    }
  }).then(r => r.json())
}

export default {
  getLinkForUser
}



// WEBPACK FOOTER //
// ./src/services/referral.service.js